import { commitMutation, Environment } from "react-relay";
import { relayAuthEnvironment } from "@/RelayEnvironment";
import { graphql } from "relay-runtime";
import {
    DisableAutoDispoInput,
    DisableAutoDispoMutationResponse,
} from "@/Domains/DispositionManagement/Mutations/__generated__/DisableAutoDispoMutation.graphql";
import { BaseError } from "@/Utils/BaseError";

export default (
    input: DisableAutoDispoInput,
    onCompleted: (error: Error | null, result?: boolean | null) => void,
) => {
    // @ts-ignore
    commitMutation(relayAuthEnvironment() as Environment, {
        mutation: graphql`
            mutation DisableAutoDispoMutation($input: DisableAutoDispoInput!) {
                DisableAutoDispoMutation(input: $input)
            }
        `,
        variables: {
            input: input,
        },
        onCompleted(result) {
            const res = result as DisableAutoDispoMutationResponse;
            const success = res.DisableAutoDispoMutation;

            if (success) {
                onCompleted(null, success);
                return;
            }

            throw new BaseError(
                "DisableAutoDispoMutation failed with an unexpected Error",
                {
                    context: {
                        stationId: input.stationId,
                    },
                },
            );
        },
        onError(err) {
            onCompleted(err);
        },
    });
};
